/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from "mbp-api-util";

export const brands = {
    1029: 'Shari\'s Berries',
    1010: 'Fruit Bouquets',
    1020: 'Wolferman\'s',
    1001: '1-800-Flowers',
    1019: 'Harry & David',
    1009: '1-800-Baskets',
    1025: 'Simply Chocolate',
    1012: 'Cheryl\'s Cookies',
    1022: 'Personalization Universe',
    1002: 'The Popcorn Factory',
    1018: 'Stock Yards',
    1030: 'Personalization Mall',
    1031: 'vitalchoice',
};

export const getSisterBrandName = (productBrand, currentBrand) => {
    if (!productBrand || !currentBrand) {
        return null;
    }
    if (productBrand !== currentBrand && brands[productBrand]) {
        return brands[productBrand];
    }
    return null;
};

export const brandByCode = {
    1001: '1800flowers',
    1019: 'harryanddavid',
    1009: '1800baskets',
    1025: 'simplychocolate',
    1010: 'fruitbouquets',
    1012: 'cheryls',
    1022: 'personalizationuniverse',
    1002: 'thepopcornfactory',
    1020: 'wolfermans',
    1018: 'stockyards',
    1030: 'personalizationmall',
};

let appRouterPrefix = '';
const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

if (REACT_APP_INJECTABLE === 'false') {
    appRouterPrefix = '/z';
}

export const getAppRoutePrefix = () => appRouterPrefix;

export const isStandalone = !!(REACT_APP_INJECTABLE === 'false')

export default {};
